import { useQuery, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { getRelativeCompAnalysis } from 'services/apiRelativeCompAnalysis';

const useGetRelativeCompData = (orderId) => {
  const queryClient = useQueryClient();

  const{isPending: isGetting, isSuccess: isGot, error: relativeCompError, data: relativeCompData} = useQuery({
    queryKey:['relCompAnalData',orderId],
    queryFn:()=> getRelativeCompAnalysis(orderId),
    keepPreviousData:true,
    staleTime: 2 * 60 * 60 * 1000,
    enabled: !!orderId
  })

  return{isGetting, isGot, relativeCompError, relativeCompData}
}

export default useGetRelativeCompData